import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleTheme = () => {
    const html = document.querySelector('html');
    const currentTheme = html?.getAttribute('data-theme');
    const newTheme = currentTheme === 'dark' ? 'portfolio' : 'dark';
    html?.setAttribute('data-theme', newTheme);
  };

  return (
    <div className={`navbar fixed w-full z-20 top-0 left-0 transition-all duration-300 ${
      isScrolled ? 'bg-base-100 shadow-md backdrop-blur-sm bg-opacity-90' : 'bg-transparent'
    }`}>
      <div className="navbar-start">
        <div className="dropdown">
          <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" />
            </svg>
          </div>
          <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow-lg bg-base-100 rounded-box w-52 gap-1">
            <li><a href="#about" className="hover:text-primary transition-colors uppercase font-bold text-sm">À propos</a></li>
            <li><a href="#skills" className="hover:text-primary transition-colors uppercase font-bold text-sm">Compétences</a></li>
            <li><a href="#projects" className="hover:text-primary transition-colors uppercase font-bold text-sm">Projets</a></li>
            <li><a href="#certifications" className="hover:text-primary transition-colors uppercase font-bold text-sm">Formations</a></li>
            {/* <li><a href="#references" className="hover:text-primary transition-colors uppercase font-bold text-sm">Références</a></li> */}
            <li><a href="#trainings" className="hover:text-primary transition-colors uppercase font-bold text-sm">Educations</a></li>
            <li><a href="#contact" className="hover:text-primary transition-colors uppercase font-bold text-sm">Contact</a></li>
          </ul>
        </div>
        <a href="/" className="btn btn-ghost normal-case text-xl">
          <span className="text-primary font-bold">Portfolio V1.0.1</span>
        </a>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1 gap-2">
          <li>
            <a href="#about" className="hover:text-primary transition-colors uppercase font-bold text-sm tracking-wider">
              À propos
            </a>
          </li>
          <li>
            <a href="#skills" className="hover:text-primary transition-colors uppercase font-bold text-sm tracking-wider">
              Compétences
            </a>
          </li>
          <li>
            <a href="#projects" className="hover:text-primary transition-colors uppercase font-bold text-sm tracking-wider">
              Projets
            </a>
          </li>
          <li>
            <a href="#certifications" className="hover:text-primary transition-colors uppercase font-bold text-sm tracking-wider">
              Formations
            </a>
          </li>
          {/* <li>
            <a href="#references" className="hover:text-primary transition-colors uppercase font-bold text-sm tracking-wider">
              Références
            </a>
          </li>
          <li> */}
          <li>
            <a href="#trainings" className="hover:text-primary transition-colors uppercase font-bold text-sm tracking-wider">
              Training
            </a>
          </li>
          <li>
            <a href="#contact" className="hover:text-primary transition-colors uppercase font-bold text-sm tracking-wider">
              Contact
            </a>
          </li>
        </ul>
      </div>
      <div className="navbar-end gap-2">
        <button onClick={toggleTheme} className="btn btn-ghost btn-circle">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
          </svg>
        </button>
        <a href="#contact" className="btn btn-primary btn-sm">
          Me contacter
        </a>
      </div>
    </div>
  );
};

export default Header;
